module.exports = "announcements"